export const CLEAR_RESOURCES = "CLEAR_RESOURCES";
export const CLEAR_MY_GROUPS = "CLEAR_MY_GROUPS";
export const SET_BREADCRUMBS = "SET_BREADCRUMBS";
